var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partner-container"},[_c('div',{staticClass:"in-sec"},[_c('h2',[_vm._v("PARTNER")]),_c('ul',_vm._l((_vm.partners),function(item){return _c('li',[_c('img',{attrs:{"src":("" + (item.img))}})])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }